import React from 'react'
import './WinnersAboutUsBlue.css'
import img1 from '../../Images/Rectangle 427.png'
import img2 from '../../Images/Rectangle 428.png'
import img3 from '../../Images/Rectangle 429.png'

const FavPropertiesBlue = () => {
  return (
    <>
     {/* <section className='fav_properties_section_blue'>
        <h1 className='fav_client_properties_head_blue'>Some of Most Favourite Client Properties</h1>
        <div className='fav_properties_images_wrapper_blue'>
            <div className='fav_property_img_blue'>
                <img src={img1} alt="Fav Property 1"></img>
            </div> 
            <div className='fav_property_img_blue'>
                <img src={img2} alt="Fav Property 2"></img>
            </div>
            <div className='fav_property_img_blue'>
                <img src={img3} alt="Fav Property 3"></img>
            </div>
        </div>
     </section>  */}

     <section className="property-showcase-blue">

  <div className="property-showcase-header-blue">
    <span className="property-tag-blue">
      Featured Properties
    </span>

    <h2>
      Properties Our Clients
      <span> Love The Most</span>
    </h2>

    <p>
      Explore some of the most viewed and highly appreciated
      properties from our verified real estate database.
    </p>
  </div>

  <div className="property-grid-blue">

    <div className="property-card-blue">
      <img src={img1} alt="Property 1" />

      <div className="property-overlay-blue">
        <h3>Luxury Residences</h3>
        <p>Premium living spaces with verified data.</p>
      </div>
    </div>

    <div className="property-card-blue">
      <img src={img2} alt="Property 2" />

      <div className="property-overlay-blue">
        <h3>Commercial Spaces</h3>
        <p>Business-ready locations with insights.</p>
      </div>
    </div>

    <div className="property-card-blue">
      <img src={img3} alt="Property 3" />

      <div className="property-overlay-blue">
        <h3>Modern Apartments</h3>
        <p>Trusted listings across NCR regions.</p>
      </div>
    </div>

  </div>

</section>
    </>
  )
}

export default FavPropertiesBlue
